import { render } from "./letter-tag-create.vue?vue&type=template&id=fa0fbfe6"
import script from "./letter-tag-create.vue?vue&type=script&lang=js"
export * from "./letter-tag-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__